'use strict';/* global define */define('modules/feedback/directives/profile-image-list/controller',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
     controller.$inject = ["$scope"];
function controller($scope){// jshint validthis:true
// jshint latedef:false
var ctrl=this;ctrl.profiles=$scope.profiles;ctrl.chooseProfile=$scope.chooseProfile;ctrl.chooseNextGroup=chooseNextGroup;ctrl.choosePreviousGroup=choosePreviousGroup;ctrl.chooseNextProfile=chooseNextProfile;ctrl.choosePreviousProfile=choosePreviousProfile;/**
     * Watch the current profile to update
     * image list accordingly
     *
     * @tested
     */$scope.$watch('currentProfile',function(newProfile){ctrl.currentIndex=ctrl.profiles.indexOf(newProfile);});// ---
/**
     * Choose the next group of profiles
     *
     * @tested
     */function chooseNextGroup(){if(ctrl.currentGroupIndex<ctrl.maxItemsGroups){var oldGroupIndex=ctrl.currentGroupIndex;++ctrl.currentGroupIndex;$scope.$broadcast('ProfileImageList.groupIndex',ctrl.currentGroupIndex,oldGroupIndex);}}/**
     * Choose the previous group of profiles
     *
     * @tested
     */function choosePreviousGroup(){if(ctrl.currentGroupIndex>0){var oldGroupIndex=ctrl.currentGroupIndex;--ctrl.currentGroupIndex;$scope.$broadcast('ProfileImageList.groupIndex',ctrl.currentGroupIndex,oldGroupIndex);}}/**
     * Choose the previous profile if it is
     * inside of the array bounds
     *
     * @tested
     */function choosePreviousProfile(){if(ctrl.currentIndex>0){--ctrl.currentIndex;ctrl.chooseProfile(ctrl.currentIndex);}}/**
     * Choose the next profile if it is
     * in inside of the array bounds
     *
     * @tested
     */function chooseNextProfile(){if(ctrl.currentIndex<ctrl.profiles.length-1){++ctrl.currentIndex;ctrl.chooseProfile(ctrl.currentIndex);}}}module.exports=controller;});
